import { useEffect } from 'react';
import { useSearchResults } from '@agissc/ktag-map';
import debounce from 'lodash.debounce';
import useAppState from '../../AppStore';
import isMatchingSearchResult from './api/isMatchingSearchResult';

interface ZoomToSearchProps {
  callback?: () => void;
}

const ZoomToSearchResult = ({ callback }: ZoomToSearchProps) => {
  const selectedResult = useAppState((state) => state.selectedSearchResult);
  const setselectedResult = useAppState((state) => state.setSelectedSearchResult);

  const { data: searchResults } = useSearchResults();

  useEffect(() => {
    if (!searchResults.length || !selectedResult) return () => {};

    const searchResult =
      searchResults.find((item) => isMatchingSearchResult(item, selectedResult)) ||
      searchResults[0];

    const debouncedSetLocation = debounce(() => {
      setselectedResult(searchResult);
      callback?.();
    }, 1000);

    debouncedSetLocation();

    return () => debouncedSetLocation.cancel();
  }, [searchResults.length]);

  return null;
};

export default ZoomToSearchResult;
